import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/following-icon.module.scss'
import { Users } from 'lucide-react'

export default function FollowingIcon(props) {
    return (
        <div className={cn(styles.followingIcon, props.contextStyles)}>
            <Users />
        </div>
    )
}
